export enum ShopItemType {
  COMMISSIONS = 'commissions',
  PRINTS = 'prints',
  PREMIUM_CONTENT = 'premium_content',
}
